"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Link_1 = __importDefault(require("../../components/Text/Link"));
const events_1 = require("../../utils/dom/events");
const links_1 = require("../../utils/dom/links");
const utils_1 = require("./utils");
exports.default = react_1.default.memo(function Link(props) {
    props.state;
    props.replace;
    const intl = (0, react_intl_1.useIntl)();
    const isLocal = (0, react_1.useMemo)(() => (0, links_1.isLocalLink)(props.href), [props.href]);
    const hrefLang = (0, react_1.useMemo)(() => (!isLocal ? props.hrefLang : props.hrefLang || intl.locale), [props.hrefLang, intl.locale]);
    const href = (0, react_1.useMemo)(() => !isLocal || hrefLang === intl.defaultLocale
        ? props.href
        : `/${hrefLang}${props.href}`, [hrefLang, props.href, intl.defaultLocale, isLocal]);
    const handleClick = (0, react_1.useCallback)((event, ...extra) => {
        if (props.onClick) {
            ;
            props.onClick(event, ...extra);
        }
        const isBlank = (0, links_1.isBlankTarget)(event.currentTarget.target);
        if (!!href &&
            !!isLocal &&
            !event.defaultPrevented &&
            !isBlank &&
            !(0, events_1.isMeta)(event)) {
            event.preventDefault();
            (0, utils_1.navigate)(href, {
                locale: hrefLang,
                state: props.state,
                replace: props.replace,
            });
        }
    }, [props.onClick, href, hrefLang, isLocal, props.state, props.replace]);
    return (react_1.default.createElement(Link_1.default, { ...props, onClick: handleClick, href: href, hrefLang: hrefLang }));
});
